module.exports = __webpack_public_path__ + "static/media/angies-list.83dd4c7c.png";